<template>
	<div class="head">
	   <div class="nav">	
		<div slot="left" class="logo"><img src="../assets/images/logo_d_19.png"></div>
    <div  slot="right" class="nav_tit">
    <van-icon name="apps-o" />
		<van-dropdown-menu>
         <van-dropdown-item  title="导航" ref="item">
            <p @click="navigation('shouye')">网站首页</p>
            <p @click="navigation('scheduleStatus')">会议日程</p>
            <p @click="navigation('reportInfoStatus')">会议报告</p>
            <p @click="navigation('meetingInfoStatus')">大会简介</p>
            <p @click="navigation('contactUsStatus')">联系我们</p>
         </van-dropdown-item>
     </van-dropdown-menu>
     </div>
	   </div>
	</div>
</template>

<script type="text/javascript">
 import { NavBar,Icon,Row, Col,DropdownMenu,DropdownItem} from 'vant';
 export default {
    data() {
      return {};
    },
    components: {
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [Row.name]: Row,
      [Col.name]: Col,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
    },

    methods: {
    go(pathName) {
        this.$router.push({ name: pathName });
    },
    navigation(meetingType){
        this.$emit("meetingType",meetingType);
        this.$refs.item.toggle();
    },
    }

  };	
</script>

  <style lang="less" scoped>
   .van-nav-bar{ background:#fff; border-bottom:none;}
   .van-nav-bar__title,.van-nav-bar__text{ color:#fff !important;}
   .nav_tit{ display: inline-block; float: right; width: 20%; text-align:center;}
   .nav_tit /deep/.van-icon{ padding-top: 10px; font-size:20px; }
   /deep/.van-dropdown-menu{ background:none;  margin-top: -40px; padding-top: 25px; }
   /deep/.van-dropdown-menu__title::after{ display:none;}
   .logo{ width: 48%;    height: 50px;display: inline-block; margin-top: 15px; margin-left: 10px;}
   .logo img{ width: 100%; }
  /deep/.van-dropdown-item__content{ border-top: #dfdfdf solid 1px; min-height: 200px; }
    /deep/.van-dropdown-item__content p{ font-size: 16px; padding:17px 0; border-bottom: #dfdfdf solid 1px; }
    .banner{ margin-top: -10px; }
    /deep/.van-ellipsis{ font-size:12px; }
  </style>
